<template>
    <div>
        <b-row>
            <b-col>
                <b-button v-b-modal="id +'modal-prevent-closing'"
                          variant="primary" :aria-describedby="describedBy">
                    Upload Document(s)
                </b-button>
            </b-col>
        </b-row>

        <b-modal hide-footer
                 :id="id +'modal-prevent-closing'"
                 ref="modal"
                 title="Upload Document"
                 @show="resetModal"
                 @hidden="resetModal"
                 @ok="handleOk">

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                    :state="$v.type.$dirty ? !$v.type.$error : null"
                    label="Type of Document"
                    label-for="type-input"
                    invalid-feedback="Type of Document is required">
                    <b-form-select id="type-input" v-model="type"
                        :state="$v.type.$dirty ? !$v.type.$error : null"
                        :options="attachmentTypeOptions"
                        :text-field="textField"
                        :value-field="valueField"
                    >
                        <template v-slot:first>
                            <option :value="null" disabled>-- Please select an option --</option>
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-form-group v-if="type === 'OT'"
                              :state="$v.othType.$dirty ? !$v.othType.$error : null"
                              label="Other Type of Upload"
                              label-for="othType-input"
                              invalid-feedback="Other file type is required">
                    <b-form-input id="othType-input" v-model="othType"
                           :state="$v.othType.$dirty ? !$v.othType.$error : null"
                           >
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    :state="$v.file.$dirty ? !$v.file.$error : null"
                    label="File to Upload"
                    label-for="file-input"
                    :validator="$v.file"
                    :invalid-feedback="file?'Invalid format':'File to Upload is required'">
                    <b-form-file
                        id="file-input"
                         v-model="file"
                         accept="application/pdf,image/jpeg"
                         :state="$v.file.$dirty ? !$v.file.$error : null"
                         placeholder="Choose a file or drop it here..."
                         drop-placeholder="Drop file here...">
                    </b-form-file>
                </b-form-group>
                <div class="text-muted">Only PDF and JPEG files are accepted.</div>
                <b-button type="submit" variant="primary" :disabled="isDisabled">Submit</b-button>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import maxFileSize from '@/validators/maxFileSize'
    import fileType from "@/validators/fileType"

    export default {
        data(){
            return {
                type: null,
                file: null,
                othType: null,
                isDisabled: false,
                op: null
            }
        },
        props: {
            attachmentTypeOptions: [Array],
            id: [String],
            order: [String],
            describedBy: [String],
            textField: [String],
            valueField: [String],
            supplementalField: [String]
        },
        validations: {
            file: { required, maxFileSize: maxFileSize(), fileType: fileType() },
            type: { required },
            othType: { required: requiredIf(function(){ return this.type === 'OT'})},
        },
        methods: {
            resetModal(){
                this.name = null
            },
            handleOk(bvModalEvt){
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },
            handleSubmit(){
                this.$v.$touch()
                if(this.$v.$invalid){
                    return
                }
                this.isDisabled = true
                const fd2 = new FormData()
                fd2.append('file', this.file)
                if (this.type instanceof Object) {
                    fd2.append('type', this.type.id)
                    fd2.append(this.supplementalField, this.type.supplemental)
                } else {
                    fd2.append('type', this.type)
                }

                if(this.othType != null){
                    fd2.append('othType', this.othType)
                }
                fd2.append('order', this.order)
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachments/new`, fd2, {params :{form: true}})
                    .then(response => {
                        this.file = null
                        this.type = null
                        this.othType = null
                        this.$emit('attachment-added', response.data)
                    })
                    .catch(error=>{
                        this.$emit('attachment-failed', error.data)
                    })
                    .finally(()=>{
                        this.$v.$reset()
                        let modalId = this.id + 'modal-prevent-closing'
                        this.$nextTick(() => {
                            this.isDisabled = false
                            this.$bvModal.hide(modalId)
                        })
                    })
            }
        },
    }
</script>